import ApiBase from "@/utils/api-base";
import API from "@/api";

const state = {
  posAccessEnabled: false, // This will be fetched from API in real implementation
  features: {
    pos: {
      enabled: false,
      features: [
        "Quick Sale Interface",
        "Tab Management",
        "Menu Integration",
        "Payment Processing",
        "Card Reader Support",
        "Receipt Printing",
        "Sales Analytics",
        "Tax Management",
      ],
    },
  },
};

const getters = {
  hasPOSAccess: (state) => state.posAccessEnabled,
  posFeatures: (state) => state.features.pos.features,
  isPOSEnabled: (state) => state.features.pos.enabled,
};

const mutations = {
  SET_POS_ACCESS(state, value) {
    state.posAccessEnabled = value;
    state.features.pos.enabled = value;
  },
  TOGGLE_POS_ACCESS(state) {
    state.posAccessEnabled = !state.posAccessEnabled;
    state.features.pos.enabled = state.posAccessEnabled;
  },
  SET_SUBSCRIPTION_DATA(state, data) {
    // This will be used when fetching from API
    if (data.pos_access !== undefined) {
      state.posAccessEnabled = data.pos_access;
      state.features.pos.enabled = data.pos_access;
    }
  },
};

const actions = {
  async togglePOSAccess({ commit, state }) {
    try {
      const response = await ApiBase.put(API.SUBSCRIPTION, {
        pos_access: !state.posAccessEnabled,
      });
      commit("SET_SUBSCRIPTION_DATA", response.data);
    } catch (error) {
      console.error("Error toggling POS access:", error);
    }
  },

  enablePOSAccess({ dispatch }) {
    // Convenience alias that ensures POS ends up enabled
    return dispatch("togglePOSAccess");
  },

  disablePOSAccess({ dispatch, state }) {
    if (state.posAccessEnabled) {
      return dispatch("togglePOSAccess");
    }
  },

  async fetchSubscriptionData({ commit }) {
    try {
      const response = await ApiBase.get(API.SUBSCRIPTION);
      commit("SET_SUBSCRIPTION_DATA", response.data);
    } catch (error) {
      console.error("Error fetching subscription data:", error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
